/* eslint-disable angular/constant-name */

angular.module("digiexam").constant("NodeTypeEnum",
	Object.freeze({
		NOTSPECIFIED: 0,
		INTERNAL: 1,
		HIGHEREDUCATION: 2,
		SECONDARTEDUCATION: 3,
		PRIMARYEDUCATION: 4,
		EDUCATIONCOMPANY: 5,
	})
);
